import { render } from "./HelpRenderer.vue?vue&type=template&id=0c36e6c8&scoped=true"
import script from "./HelpRenderer.vue?vue&type=script&lang=js"
export * from "./HelpRenderer.vue?vue&type=script&lang=js"

import "./HelpRenderer.vue?vue&type=style&index=0&id=0c36e6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c36e6c8"]])

export default __exports__